import React from "react";
import { motion } from "framer-motion";
import { Sparkles, Rocket, Film } from "lucide-react";
import SectionTitle from "./SectionTitle";

export default function FeaturesSection() {

  const items = [
    {
      title: "Studio-grade UI & polish",
      desc: "We care about feel. Menus, transitions, micro-interactions — everything is intentional.",
      icon: Sparkles,
    },
    {
      title: "Fast prototyping loop",
      desc: "We prototype quickly, validate early, and scale what works into production-ready builds.",
      icon: Rocket,
    },
    {
      title: "Cinematic presentation",
      desc: "Modern visuals with bold typography and trailer-ready branding from day one.",
      icon: Film,
    },
  ];

  return (
    <section id="studio" className="bg-black">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:py-20">

        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <SectionTitle
            eyebrow="How we build"
            title="A focused studio workflow"
            desc="Clean process, high quality, and fast iteration — the ProPlay way."
          />
        </motion.div>

        {/* Cards */}
        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {items.map((it, idx) => {
            const Icon = it.icon;

            return (
              <motion.div
                key={it.title}
                className="group rounded-2xl border border-white/10 bg-white/5 p-6 transition hover:border-white/20"
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 0.6, ease: "easeOut", delay: idx * 0.06 }}
                whileHover={{ y: -6 }}
              >
                {/* ICON */}
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-brand-red/20 ring-1 ring-brand-red/30 transition group-hover:bg-brand-red/30">
                  <Icon
                    size={22}
                    className="text-brand-red transition group-hover:scale-110"
                  />
                </div>

                {/* TEXT */}
                <div className="text-lg font-semibold text-white">
                  {it.title}
                </div>

                <p className="mt-2 text-sm leading-relaxed text-white/65">
                  {it.desc}
                </p>
              </motion.div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
